export const LigeriaMark = ({ className = "h-10 w-10" }) => (
  <img
    src="/logo-ligeria.jpg"
    alt="Logo Ligéria Sport Concept"
    className={`${className} rounded-full object-cover shadow-[0_2px_12px_rgba(0,0,0,0.45)]`}
    data-testid="logo-ligeria"
  />
);

export const LigeriaWordmark = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LigeriaMark className={compact ? "h-9 w-9" : "h-11 w-11"} />
    <span className="flex flex-col leading-none">
      <span className={`font-display text-white tracking-wide ${compact ? "text-lg" : "text-xl"}`}>
        LIGÉRIA
      </span>
      <span className="font-accent text-[10px] tracking-[0.42em] text-white/55 mt-1">
        SPORT CONCEPT
      </span>
    </span>
  </span>
);

export const PantherWordmark = ({ big = false, dark = false }) => (
  <span className="flex flex-col items-start">
    <img
      src="/img/panther-band.png"
      alt="Logo PANTHER"
      className={`${big ? "h-16 md:h-20" : "h-10"} w-auto`}
      data-testid="logo-panther"
    />
    <span className={`font-accent uppercase tracking-[0.5em] ${dark ? "text-black/50" : "text-white/50"} ${big ? "text-sm mt-3" : "text-[10px] mt-2"}`}>
      Design for you
    </span>
  </span>
);
